import PIXI from 'pixi.js/src';
import data from './../data/data';
import renderHelper from './../helpers/render';
import frameAnimationHelper from './../helpers/frame-animation';
import audioHelper from './../helpers/audio';
import GameStore from './../stores/GameStore';

const explosion = {
  explosionWidth: 42,
  explosionHeight: 42,
  explosionAnimationImagePaths: [],


  /**
   * Sets up, adds event listeners
   * @returns {undefined} undefined
   */
  init() {
    this.gameStoreListener = this.onGameStoreChange.bind(this);
    GameStore.addChangeListener(this.gameStoreListener);

    this.explosionAnimationImagePaths = data.explosionPaths;
  },


  /**
   * Creates a explosion
   * @param {Number} x - The x position of the explosion
   * @param {Number} y - The y position of the explosion
   * @returns {undefined} undefined
   */
  create(x, y) {
    const _this = this;

    this.explosionContainer = new PIXI.Container();

    frameAnimationHelper.create(
      this.explosionContainer,
      this.explosionAnimationImagePaths,
      0.3,
      false,
      this.explosionWidth,
      this.explosionHeight);

    this.explosionContainer.x = x;
    this.explosionContainer.y = y;
    renderHelper.stage.addChild(this.explosionContainer);
    // audioHelper.playSound('allsounds', 1, false, 0.15, 0.7);

    setTimeout(() => {
      renderHelper.stage.removeChild(_this.explosionContainer);
    }, 300);
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const state = GameStore.getState();

    if (state.explosionToRemove &&
      state.explosionToRemove._gameId === this.explosionSprite._gameId) {
      this.destroy();
    }
  },


  /**
   * Destroys the explosion
   * @returns {undefined} undefined
   */
  destroy() {
    GameStore.removeChangeListener(this.gameStoreListener);
    renderHelper.stage.removeChild(this.explosionSprite);
    this.explosionSprite = null;
  },
};

export default explosion;



/** WEBPACK FOOTER **
 ** ./assets/js/src/graphics/explosion.js
 **/